import * as React from 'react';

import { auth } from '../../firebase';
import AppConfig from '../../config/AppConfig';

// const SignOutButton = () =>
  

class SignOutButton extends React.Component<any,any> {

  constructor(props:any) {
    super(props);

    // this.state = {
    //   isVisible: false
    // }

    // firebase.auth.onAuthStateChanged(authUser => {
    //   console.log("LOADED!");
    // });
  }

  private getSignOutText():string {
    if (AppConfig.userData) {
      return "Not " + AppConfig.userData.firstName + " " + AppConfig.userData.lastName + "? ";
    }
    return "";
  }

  render() {
    return (
      <div onClick={auth.doSignOut} className='signOutBtn'>
        {this.getSignOutText()}<span>Sign out</span>
      </div>
    );
  }
}

export default SignOutButton;



// WEBPACK FOOTER //
// ./src/components/routes/SignOut.tsx